module.exports = {"TXTMOB_Yesterday":{"id":"TXTMOB_Yesterday","defaultMessage":"Gestern","track":"Yesterday"}}